import { Box, CardContent, CardHeader, makeStyles, Typography, useTheme } from '@material-ui/core'
import React from 'react'
import { styles } from './cardEmptyContent.styles'
import { CardWithTransition } from '../cardWithTransition/CardWithTransition'

export interface CardEmptyContentProps {
  title?: string
  caption?: string
}

export const CardEmptyContent: React.FC<CardEmptyContentProps> = ({
  title = '',
  caption = '',
  children
}) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  return (
    <CardWithTransition show={true} raised>
      <CardHeader title={title} titleTypographyProps={{ variant: 'h2', color: 'secondary' }} />
      <CardContent className={classes.cardContent}>
        <Box margin="auto" mt={1} mb={1}>
          <Typography variant="subtitle1">{caption}</Typography>
        </Box>
        <Box margin="auto" mb={title ? 4 : 0}>
          {children}
        </Box>
      </CardContent>
    </CardWithTransition>
  )
}
